// extracted by mini-css-extract-plugin
export default {"modal":"oO-z","modalOverlay":"pO-z","outfitHeading":"qO-z"};